import digitalData from 'digital-data';
import { INTERACTION, LIST_SETTINGS } from '../constants';

export const listForms = () => {
  LIFE_CYCLE_EVENT_BUS.on('list-forms.settings-form-load', () => {
    const ddoEvent = {
      category: {
        primaryCategory: 'overlay'
      },
      eventInfo: {
        eventName: LIST_SETTINGS
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('list-forms.settings-save', ({ output }) => {
    const settings = `lists: ${LIST_SETTINGS}: ${output?.type}`;
    const ddoEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      myAccount: {
        settings
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('list-forms.list-delete', ({ output }) => {
    const ddoEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'delete list'
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('list-forms.create-without-products', ({ output }) => {
    const settings = output?.settings;
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: 'create list'
      },
      myList: {
        creationLocation: 'list summary'
      }
    };
    
    if (settings) {
      ddoEvent.myAccount = {
        settings: `lists: ai false door test: ${settings}`
      }
    }
    
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('list-forms.save-a-shared-list', () => {
    const ddoEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      myAccount: {
        settings: 'lists: shared list: save to lists link'
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('list-forms.create-new-overlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: 'overlay'
      },
      eventInfo: {
        eventName: 'create new list'
      }
    };
    digitalData.event.push(ddoEvent);
  });
};